import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useLoader } from '../../../../hooks/useLoader'

import { addSms, premiumWelcome } from '../../../../actions/adminActions'
import { Button, ButtonExt } from '../../../utils/Button'

const Actions = () => {
  const loading = useLoader()
  const dispatch = useDispatch()
  const user = useSelector(store => store.admin.user)

  return (
    <div className="flex my-4 space-x-2">
      <ButtonExt color="orange" className="flex-grow" href={user.loginUrl}>
        Login As
      </ButtonExt>
      <Button color="green" disabled={loading} className="flex-grow" onClick={() => dispatch(addSms(user.id))}>
        +250 Sms
      </Button>
      <Button color="gray" disabled={loading} className="flex-grow" onClick={() => dispatch(premiumWelcome(user.id))}>
        Premium Welcome
      </Button>
    </div>
  )
}

export default Actions
